export interface ErrorResult {
    title: string;
    details?: Record<string, unknown>;
}

export class ClientError<TErrorResult extends ErrorResult = ErrorResult> extends Error {
    private readonly _result: TErrorResult | null;

    get title() {
        return this._result?.title || null;
    }

    get details() {
        return this._result?.details || null;
    }

    constructor(result?: TErrorResult) {
        super();
        this._result = result || null;
    }
}
